<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-space-y-3">
        <div class="row">
          <div class="col-md-12">
            <label class="ts-mb-0 required ts-font-robot">
              {{ $t('projectProfile.status') }}
            </label>
            <a-select
              v-model="model.status_id"
              :options="projectStatus"
              show-search
              option-filter-prop="children"
              :filter-option="filterOption"
              class="ts-w-full"
              placeholder="Select project status"
            ></a-select>
            <div class="validate" v-if="errors.has('status_id')">
              {{ errors.first('status_id') }}
            </div>
          </div>
        </div>

        <div class="row">
          <div
            class="col-md-12 ts-flex ts-items-center ts-justify-end ts-space-x-3"
          >
            <ts-button @click.prevent="$emit('cancel')">
              {{ $t('cancel') }}
            </ts-button>
            <ts-button color="primary" @click.prevent="onUpdate">
              {{ $t('update') }}
            </ts-button>
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'

export default {
  props: ['updateData'],
  data() {
    return {
      loading: false,
      projectStatus: [],
      errors: new Errors(),
      model: {
        project_id: '',
        status_id: ''
      }
    }
  },
  created() {
    if (this.updateData) {
      this.model.project_id = this.updateData.project_id
      this.model.status_id = this.updateData.status_id
    }
    this.fetchViewModel()
  },
  methods: {
    ...mapActions('report/project', ['formViewModel', 'update']),

    fetchViewModel() {
      this.loading = true
      this.formViewModel({
        fnName: 'status',
        project_id: this.model.project_id
      })
        .then(response => {
          this.projectStatus = response.data.status.map(el => ({
            value: el.status_id,
            label: el.project_status
          }))

          const found = this.projectStatus.find(
            s => s.label === this.updateData.project_status
          )
          this.model.status_id =
            this.updateData.status_id || (found ? found.value : '')
        })
        .catch(error => this.$toasted.error(error.message))
        .finally(() => (this.loading = false))
    },

    async onUpdate() {
      if (!this.model.project_id) {
        this.$toasted.error('Project ID is missing. Cannot update.')
        return
      }

      if (!this.model.status_id) {
        this.$toasted.error('Please select a status')
        return
      }

      this.loading = true
      this.errors = new Errors()

      try {
        const response = await this.update({
          id: this.model.project_id,
          data: { status_id: this.model.status_id }
        })
        this.$toasted.success(response.message)
        this.$emit('updated')
      } catch (err) {
        this.$toasted.error(err.message)
        this.errors = new Errors(err.errors)
      } finally {
        this.loading = false
      }
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text
        .toLowerCase()
        .includes(input.toLowerCase())
    },
  }
}
</script>
